import request from "@/utils/request";

const base = "/api/mts-api/workflow-chat/v1";
async function call(path, method = "get", data, params) {
  try {
    const result = await request({ url: base + path, method, data, params, skipLoading: true, skipErrorMessage: true });
    if (Number(result?.code) !== 200) throw Object.assign(new Error(result?.msg || "流程讨论加载失败"), { errorCode: result?.errorCode });
    return result.data;
  } catch (error) {
    const body = error.response?.data;
    if (body?.msg) error.message = body.msg;
    if (body?.errorCode) error.errorCode = body.errorCode;
    throw error;
  }
}
export const workflowChatHasUnread = () => call("/unread");
export const workflowChatAvailable = () => call("/availability");
export const workflowChatFeatures = () => call("/features");
export const getWorkflowChatMentions = (id) => call(`/groups/${encodeURIComponent(id)}/mentions`);
export const workflowChatOptions = (scope) => call("/options", "get", undefined, scope);
export const previewWorkflowChat = (scope) => call("/preview", "post", scope);
export const openWorkflowChat = (data) => call("/groups", "post", data);
export const enterWorkflowChat = (scope) => call("/groups/enter", "post", scope);
export const listWorkflowChats = (archived = false, offset = 0) => call("/groups", "get", undefined, { archived, offset });
export const getWorkflowChat = (id) => call(`/groups/${encodeURIComponent(id)}`);
export const getWorkflowChatMessages = (id, params) => call(`/groups/${encodeURIComponent(id)}/messages`, "get", undefined, params);
export const sendWorkflowChatMessage = (id, data) => call(`/groups/${encodeURIComponent(id)}/messages`, "post", data);
export const readWorkflowChat = (id, sequence) => call(`/groups/${encodeURIComponent(id)}/read`, "put", { sequence });
export const workflowChatAgentAvailable = (groupId) => call("/agent-availability" + (groupId ? `?groupId=${encodeURIComponent(groupId)}` : ""));
export const listWorkflowChatAgentTasks = (id, workflowRound) => call(`/groups/${encodeURIComponent(id)}/agent-tasks`, "get", undefined, { workflowRound });
export const createWorkflowChatAgentTask = (id, data) => call(`/groups/${encodeURIComponent(id)}/agent-tasks`, "post", data);
export const getWorkflowChatAgentTask = (id, taskId) => call(`/groups/${encodeURIComponent(id)}/agent-tasks/${encodeURIComponent(taskId)}`);
export const cancelWorkflowChatAgentTask = (id, taskId, expectedVersion) => call(`/groups/${encodeURIComponent(id)}/agent-tasks/${encodeURIComponent(taskId)}/cancel`, "post", { expectedVersion });
